import { Card, IconButton, Stack } from "@mui/material";
import React, { useCallback, useContext, useState } from "react";

import LocationIcon from "@mui/icons-material/LocationOnOutlined";
import PictureAsPdfIcon from "@mui/icons-material/PictureAsPdf";
import DownloadIcon from "@mui/icons-material/GetApp";
import { urlCheck } from "../../../utility/helper";
import { GenerateNewDocumentUrl } from "../../../utility/generate-new-document-url";
import { checkVisibility } from "../../../../src/utility/data-configurator-helper";
import datastore from "../../../store/hoa-datastore";


const HoaPdfContainer = ({ file }: { file: any }) => {
	const onFileDownloadClick = async (url: string) => {
		const newUrl = await GenerateNewDocumentUrl.getNewUrl(
			url,
			"hoa",
			"newsLetterNotificationFiles"
		);
		if (newUrl) {
			window.open(urlCheck(newUrl), "_blank");
		} else {
			window.open(urlCheck(url), "_blank");
		}
	};

	return (
		<div style={{ cursor: "pointer", width: "312px" }} className="pdf-container">
			<Stack direction={"row"} alignItems={"center"}>
				<PictureAsPdfIcon style={{ width: "20px", height: "20px" }} />
				<span style={{ marginLeft: "14px" }} className="text-3E3E3E-14px normal">
					{file?.fileName}
				</span>
			</Stack>
			<DownloadIcon
				onClick={() => {
					onFileDownloadClick(file.url);
				}}
				style={{ width: "20px", height: "20px", color: "#3576E5" }}
			/>
		</div>
	);
};

const HoaEventComponent = ({ hoaEvents }: { hoaEvents: any }) => {
	const isHoaVisible = useCallback(
		(type: string) => {
			if (Object.keys(datastore.selectedConfiguration).length === 0) {
				return true;
			}
			const dataConfigAmenities =
				datastore.selectedConfiguration["Overview"]["Hoa Events"][
					"Show the added hoa events"
				];
			return checkVisibility(dataConfigAmenities, type);
		},
		[datastore.selectedConfiguration]
	);

	return (
		<Stack>
			<Stack mt={2} gap={2}>
				{hoaEvents.map((hoaEvent: any, index: number) => {
					const {
						eventDate,
						endDate,
						fromTime,
						toTime,
						title,
						address,
						newsLetterNotificationFiles,
						additionalInformation
					} = hoaEvent;
					return (
						<Card key={index} className="access-info-card" variant="outlined">
							<Stack flexDirection={"row"} gap={1}>
								{isHoaVisible("Date") && (
									<span className="text-787878-12px">
										{new Date(eventDate).toLocaleDateString()}
										{endDate && ` - ${new Date(endDate).toLocaleDateString()}  |`}
									</span>
								)}

								{isHoaVisible("Time") && (
									<span className="text-787878-12px">{`${fromTime}-${toTime}`}</span>
								)}
							</Stack>
							{isHoaVisible("Title") && (
								<span className="text-3E3E3E-14px">{title || "N/A"}</span>
							)}

							{isHoaVisible("Address") && (
								<Stack alignItems={"center"} flexDirection={"row"} gap={1}>
									<LocationIcon />
									<span className="text-787878-12px">{address}</span>
								</Stack>
							)}
							{isHoaVisible("Additional Information") && (
								<Stack direction={"row"} mt={1} p={"2px"} alignItems={"center"}>
										<span style={{fontSize: '12px', color:"#787878"}}>{additionalInformation}</span>
								</Stack>
							)}
							{isHoaVisible("Newsletter & Notification") &&
								newsLetterNotificationFiles?.length > 0 &&
								newsLetterNotificationFiles.map((file: any, index: number) => (
									<HoaPdfContainer key={index} file={file} />
								))}
						</Card>
					);
				})}
			</Stack>
		</Stack>
	);
};

export default HoaEventComponent;
